import { TransferWorkshopStoreDetailPrintModel } from "./transfer-workshop-store-detail-print.model";

export class TransferWorkshopStorePrintModel {
    transferWorkshopStoreId: number = 0;
    enterpriseLogo: string | null = null;
    enterpriseName: string = '';
    consecutive: number = 0;
    alterNumber: number | null = null;
    branchName: string = '';
    branchAddress: string = '';
    branchPhone: string = '';
    observation: string = '';
    dateTransferWorkshopStore: Date = new Date();
    typeTransferWorkshopStore: string = '';
    stateTransferWorkshopStore: string = '';
    userAuthenticated: string = '';
    transferWorkshopStoreDetails: TransferWorkshopStoreDetailPrintModel[] = [];
}
